export default {
    invalidCredentials: 'Invalid username or password'
}
